import { Dispatch } from "redux";
import {
  ERROR_LOADING_PORTALS,
  GET_ALL_PORTALS,
  RESET_DATA,
  START_LOADING_PORTALS,
  STOP_LOADING_PORTALS,
} from "./action-types";
import apiLibrary from "services/api";
import { generateQueryStringForUsers } from "utils/convertFiltersToQueryString";
import { Toasts } from "view/components/Toasts";

export const fetchDataPortalsAction =
  () => async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: START_LOADING_PORTALS });
    try {
      const currentState = getState();
      const queryParams = generateQueryStringForUsers(
        currentState.Filters.dataPortalFilter
      );
      const { data } = await apiLibrary.DataPortal.getAllPortals(queryParams);
      dispatch({
        type: GET_ALL_PORTALS,
        payload: data,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
      dispatch({
        type: RESET_DATA,
      });
      console.log("An error occurred while fetching the user profile:", error);
      dispatch({ type: ERROR_LOADING_PORTALS });
      // dispatch(fetchError(error))
    } finally {
      dispatch({ type: STOP_LOADING_PORTALS });
      // dispatch(loadingState(false))
    }
  };

  